<script>
    export default {
        components: {},
        props: {
            media: {
                type: Object
            },
            linkToDetail: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                selectedMediaData: [],
            }
        },
        computed: {
            selectedMediaIds: {
                get: function () {
                    return scoopOS.getSelected('medias');
                },
                set: function (newValue) {
                    scoopOS.replaceAll('medias', newValue);
                }
            },
            isSelected() {
                return -1 !== _.indexOf(this.selectedMediaIds, this.media.id);
            }
        },
        methods: {
            showDetailsAction(model) {
                if (this.linkToDetail) {
                    window.location.href = model.pimUrl;
                } else {
                    this.toogleSelection(model);
                }
            },
            toogleSelection(model) {
                const existingIndex = _.indexOf(this.selectedMediaIds, model.id);
                if (existingIndex !== -1) {
                    this.selectedMediaIds.splice(existingIndex, 1);
                } else {
                    this.selectedMediaIds.push(model.id);
                }

                axios.post(this.baseUrl + '/modelSelector/model/medias/select', {
                    toggle: model.id
                });
            }
        },
    }
</script>
<template>
    <div class="media-image file-box">
        <div class="file" :class="{ selected: isSelected }">
            <span class="corner"></span>
            <div class="image">
                <slot name="icons">
                    <span v-if="media.failed_validations && media.failed_validations.length"
                          class="label inside label-warning m-xs">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    <span v-if="media.clipped_images && media.clipped_images.length"
                          class="label inside label-warning m-xs">
                        <i class="fa fa-crop" aria-hidden="true"></i>
                    </span>
                </slot>

                <img @click="showDetailsAction(media)" class="img-responsive" :src="media.previewImageUrl">
            </div>

            <a @click="toogleSelection(media)">
                <div class="file-name ellipsis">
                    <span v-if="media.filename.length > 22" data-toggle="tooltip" data-placement="bottom" title=""
                          :data-original-title="media.filenameAltWrap" v-text="media.filenameShortened"></span>
                    <span v-else v-text="media.filenameShortened"></span>
                    <br/>
                    <small>{{ media.updated_at }}</small>
                </div>
            </a>
        </div>
    </div>
</template>
